import { useEffect } from 'react';

export default function useDocumentTitle(title) {
  useEffect(() => {
    if (title) {
      document.title = `Pedersen Byg - ${title}`;
    } else {
      document.title = 'Pedersen Byg';
    }
  }, [title]);
}
